export default __webpack_public_path__ + "static/media/r8.e4ee871d.jpg";